/* Collett v3 — productpagina.
   Maatkeuze, koopknop, uitwegblok en galerij. De winkelvoorraad per maat is
   er op 21-10-2026 uit gehaald: de winkels staan al in de kop en de voet, en
   op de productpagina leidde de lijst af van de maatkeuze.                 */
(() => {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const rust = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const raster = $('#maatraster');
  if (!raster) return;

  const knop     = $('#koopknop');
  const invoer   = $('#v3-variant');
  const alt      = $('#alt');
  const altmodel = $('#altmodel');
  const sectie   = raster.closest('.shopify-section');
  const sectieId = sectie ? sectie.id.replace('shopify-section-', '') : null;

  let varianten = [];
  try { varianten = JSON.parse(($('#v3-varianten') || {}).textContent || '[]'); } catch (e) {}

  const maten = $$('.maat', raster);

  /* ---------- koopbalk die meescrollt ----------
     Eén bron van waarheid: de balk spiegelt de echte koopknop (tekst en
     stand) en stuurt een klik daarheen door. Staat er nog geen maat, dan
     brengt hij je naar het matenraster — een knop die niets doet is erger dan
     geen knop. */
  const balk = $('#koopbalk');
  const balkKnop = $('#koopbalkknop');

  /* Op desktop verdwijnt de balk zodra de voettekst in beeld komt: daar staat
     de koopkolom al naast de foto, en zweefde de balk anders over de
     betaalmerken en de nieuwsbrief heen (Jarno, 24-10-2026). Op mobiel blijft
     de balk gewoon staan; daar is hij het enige wat je koopt. */
  const voet = document.querySelector('footer');
  const voetInBeeld = () => innerWidth >= 1000 && !!voet && voet.getBoundingClientRect().top < innerHeight - 40;

  const spiegelBalk = () => {
    if (!balkKnop || !knop) return;
    balkKnop.textContent = knop.textContent;
    /* Niet disabled: zonder maat is dit de weg naar het matenraster. */
    balkKnop.dataset.geenMaat = knop.disabled ? 'ja' : '';
  };

  if (balk && balkKnop && knop) {
    balkKnop.addEventListener('click', () => {
      if (balkKnop.dataset.geenMaat === 'ja') {
        raster.scrollIntoView({ block: 'center', behavior: rust ? 'auto' : 'smooth' });
        const eerste = raster.querySelector('.maat:not([data-uit]):not([disabled])');
        if (eerste) eerste.focus({ preventScroll: true });
        return;
      }
      knop.click();
    });

    /* De balk komt pas als de echte knop uit beeld is. IntersectionObserver en
       geen scrollteller: dat is één berekening in plaats van één per pixel. */
    const kijker = new IntersectionObserver((lijst) => {
      lijst.forEach((e) => {
        /* De balk hoort er ook te zijn vóórdat je bij de knop bent: je scrollt
           naar de maten en wilt dan kunnen kopen. Dus zodra de echte knop niet
           in beeld is en je voorbij de kop bent, schuift hij op. */
        const uitBeeld = !e.isIntersecting && scrollY > 320 && !voetInBeeld();
        balk.toggleAttribute('data-open', uitBeeld);
        balk.setAttribute('aria-hidden', uitBeeld ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    kijker.observe(knop);

    /* Bij scrollen zonder dat de knop van zichtbaarheid wisselt (je blijft in
       het middenstuk) komt de waarnemer niet langs; vandaar een lichte
       controle op scroll. */
    let staatBalk = false;
    addEventListener('scroll', () => {
      const r = knop.getBoundingClientRect();
      const zichtbaar = r.top < innerHeight - 40 && r.bottom > 0;
      const tonen = !zichtbaar && scrollY > 320 && !voetInBeeld();
      if (tonen === staatBalk) return;
      staatBalk = tonen;
      balk.toggleAttribute('data-open', tonen);
      balk.setAttribute('aria-hidden', tonen ? 'false' : 'true');
    }, { passive: true });

    spiegelBalk();
    /* De knoptekst verandert bij elke maatkeuze; die wijziging spiegelen we. */
    new MutationObserver(spiegelBalk).observe(knop, {
      childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled']
    });
  }

  /* ---------- prijs van de gekozen maat ----------
     Een paar kan per maat een andere prijs hebben. Zonder dit bleef de pagina
     op de laagste prijs staan terwijl het mandje de echte rekende: EU 44 stond
     er voor €174,95 en kostte €199,95 (02-11-2026). De bedragen staan in
     centen in #v3-varianten; de notatie is die van money_without_trailing_zeros. */
  const prijsEl = $('#koopprijs');
  const balkPrijsEl = $('#koopbalkprijs');
  const prijsBasis = prijsEl ? { html: prijsEl.innerHTML, sale: prijsEl.classList.contains('koop__prijs--sale') } : null;
  const balkBasis = balkPrijsEl ? balkPrijsEl.textContent : '';

  const bedrag = (cent) => '€' + (cent / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');

  const toonPrijs = (v) => {
    if (!v) return;
    const korting = v.compare_at_price > v.price;
    if (prijsEl) {
      prijsEl.textContent = bedrag(v.price);
      prijsEl.classList.toggle('koop__prijs--sale', korting);
      if (korting) {
        const oud = document.createElement('s');
        oud.className = 'mono';
        oud.style.cssText = 'color:var(--tweede);font-size:13px;margin-left:8px';
        oud.textContent = bedrag(v.compare_at_price);
        prijsEl.append(oud);
      }
    }
    if (balkPrijsEl) balkPrijsEl.textContent = bedrag(v.price);
  };

  const herstelPrijs = () => {
    if (prijsEl && prijsBasis) {
      prijsEl.innerHTML = prijsBasis.html;
      prijsEl.classList.toggle('koop__prijs--sale', prijsBasis.sale);
    }
    if (balkPrijsEl) balkPrijsEl.textContent = balkBasis;
  };

  /* ---------- maatkeuze ---------- */
  /* Zet de gekozen maat; uitverkochte maten krijgen alleen een tekst. */
  const kies = (b) => {
    const was = b.getAttribute('aria-pressed') === 'true';
    maten.forEach((m) => m.setAttribute('aria-pressed', 'false'));

    if (was) {
      /* dezelfde maat nogmaals: selectie opheffen */
      if (knop) { knop.disabled = true; knop.textContent = 'Kies eerst een maat'; }
      if (alt) alt.removeAttribute('data-open');
      herstelPrijs();
      return;
    }

    b.setAttribute('aria-pressed', 'true');
    const id = b.dataset.variant;
    const v = varianten.find((x) => String(x.id) === String(id));
    const maat = b.dataset.maat;

    toonPrijs(v);

    try { if (maat) localStorage.setItem('collett.maat', maat); } catch (e) {}

    if (invoer) invoer.value = id;

    /* De apps luisteren hiernaar: Winkelvoorraad werkt zijn lijst per winkel
       bij, Restock Alerts weet welke maat het betreft en Size Advisor volgt
       welke maat aanstaat. Ze krijgen het volledige variantobject uit
       #v3-varianten mee, dus inclusief prijs, voorraad en opties.

       Alleen als die variant ook echt gevonden is: een detail zonder variant
       laat een app die detail.variant.id leest struikelen. Bij een maatknop
       kan dat niet misgaan — #v3-varianten bevat alle varianten van dit paar
       — maar een lege melding sturen is nooit nuttig. */
    if (v) {
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
    }

    if (v && v.available) {
      if (knop) { knop.disabled = false; knop.textContent = 'In winkelmandje'; }
      if (alt) alt.removeAttribute('data-open');
    } else {
      if (knop) { knop.disabled = true; knop.textContent = `Maat ${b.querySelector('span').textContent.trim()} is uitverkocht`; }
      if (alt) {
        alt.setAttribute('data-open', '');
        if (altmodel && maat) {
          const u = new URL(altmodel.href, location.origin);
          u.searchParams.set('filter.v.option.maat', maat);
          altmodel.href = u.pathname + u.search;
          altmodel.textContent = altmodel.textContent.replace(/in .*$/, `in EU ${maat} →`);
        }
      }
    }
  };

  /* Restock Alerts (app-embed "Hou me op de hoogte"): een klik op een
     uitverkochte maat opent het meldpaneel van de app, en uitverkochte maten
     krijgen een belletje. Staat de embed uit, dan gebeurt er niets extra's en
     blijft alleen de uitweg "Deze maat is op" staan. */
  const restock = () => document.querySelector('[data-ra-laag]');
  const meldRestock = (b) => {
    if (!restock()) return;
    const v = varianten.find((x) => String(x.id) === String(b.dataset.variant));
    if (!v || v.available) return;
    const label = b.querySelector('span') ? b.querySelector('span').textContent.trim() : '';
    document.dispatchEvent(new CustomEvent('jabl:restock-open', { detail: { variantId: v.id, size: label } }));
  };
  maten.forEach((b) => b.addEventListener('click', () => { kies(b); meldRestock(b); }));
  if (restock()) {
    const stijl = document.createElement('style');
    stijl.textContent = '.maat-bel{position:absolute;top:4px;right:4px;width:12px;height:12px;pointer-events:none;color:currentColor;opacity:.75}.maat-bel svg{display:block;width:100%;height:100%;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}';
    document.head.appendChild(stijl);
    maten.forEach((b) => {
      const v = varianten.find((x) => String(x.id) === String(b.dataset.variant));
      if (!v || v.available || b.querySelector('.maat-bel')) return;
      if (getComputedStyle(b).position === 'static') b.style.position = 'relative';
      const bel = document.createElement('span');
      bel.className = 'maat-bel';
      bel.setAttribute('aria-hidden', 'true');
      bel.innerHTML = '<svg viewBox="0 0 24 24"><path d="M6 9a6 6 0 0 1 12 0c0 6 2.5 7.5 2.5 7.5h-17S6 15 6 9z"/><path d="M10 20a2.2 2.2 0 0 0 4 0"/></svg>';
      b.appendChild(bel);
      b.setAttribute('aria-label', (b.getAttribute('aria-label') || b.textContent.trim()) + ', uitverkocht — meld je aan');
    });
  }

  /* pijltjes door het maatraster */
  raster.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    const i = maten.indexOf(document.activeElement);
    if (i < 0) return;
    e.preventDefault();
    const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + maten.length) % maten.length;
    maten[n].focus();
  });

  /* ---------- onthouden maat toepassen, maar alleen als hij er ligt ---------- */
  let onthouden = null;
  try { onthouden = localStorage.getItem('collett.maat'); } catch (e) {}
  if (onthouden) {
    const treffer = maten.find((m) => m.dataset.maat === onthouden);
    /* Ligt de maat er, dan staat de koopknop meteen klaar. Ligt hij er niet,
       dan verschijnt meteen de uitweg in plaats van een dood formulier —
       kies() zet de knop dan zelf op uitverkocht. Nooit stilletjes een
       andere maat voorselecteren. */
    if (treffer) kies(treffer);
  }

  /* ---------- galerij ---------- */
  const hoofd = $('#hoofdbeeld');
  $$('.galerij__rij button').forEach((b) => {
    b.addEventListener('click', () => {
      $$('.galerij__rij button').forEach((x) => x.setAttribute('aria-current', 'false'));
      b.setAttribute('aria-current', 'true');
      if (!hoofd) return;
      const bron = b.dataset.groot || b.querySelector('img').src;
      if (rust) { hoofd.src = bron; hoofd.removeAttribute('srcset'); return; }
      hoofd.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-out' })
        .onfinish = () => {
          hoofd.src = bron;
          hoofd.removeAttribute('srcset');
          hoofd.animate([{ opacity: 0, transform: 'scale(.985)' }, { opacity: 1, transform: 'none' }],
            { duration: 280, easing: 'cubic-bezier(.2,.8,.2,1)' });
        };
    });
  });

  /* ---------- toevoegen zonder paginalading ---------- */
  const form = $('#v3-koopform');
  if (form && window.COLLETT) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!invoer || knop.disabled) return;
      const tekst = knop.textContent;
      knop.disabled = true;
      knop.textContent = 'Bezig…';
      try {
        const r = await fetch(window.COLLETT.routes.toevoegen, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +invoer.value, quantity: 1 }] })
        });
        if (!r.ok) throw new Error();
        document.dispatchEvent(new CustomEvent('collett:toegevoegd', { detail: { bron: knop, variant: invoer.value } }));
        knop.textContent = 'Toegevoegd';
        setTimeout(() => { knop.textContent = tekst; knop.disabled = false; }, 1600);
      } catch (err) {
        knop.textContent = 'Niet gelukt — probeer opnieuw';
        setTimeout(() => { knop.textContent = tekst; knop.disabled = false; }, 2200);
      }
    });
  }
})();

/* ───────── Ook in jouw maat ─────────
   De sectie rendert meer kandidaten dan er getoond worden; hier blijven de
   paren over die in de onthouden maat liggen. Liquid kent die maat niet, want
   hij staat in localStorage — gezet zodra iemand ergens een maat aantikt, ook
   op deze pagina zelf.

   Geen maat bekend of te weinig treffers? Dan blijft de sectie verborgen. Een
   kop "Ook in jouw maat" boven een willekeurige rij belooft iets wat we niet
   waarmaken. */
(() => {
  const sectie = document.querySelector('[data-ookmaat]');
  const rij = sectie && sectie.querySelector('[data-ookmaat-rij]');
  if (!rij) return;

  const kop = sectie.querySelector('[data-ookmaat-kop]');
  const basiskop = kop ? kop.textContent.trim() : '';
  const kaarten = Array.from(rij.querySelectorAll('[data-kaart]'));
  const hoeveel = 8;

  const filter = () => {
    let maat = null;
    try { maat = localStorage.getItem('collett.maat'); } catch (e) { /* privémodus */ }

    /* Zonder bekende maat: wel tonen, maar met een neutrale kop en gewoon de
       eerste paren. Anders zag bijna niemand deze rij, want de maat komt pas
       binnen zodra iemand er ergens een aantikt. */
    let getoond = 0;
    kaarten.forEach((k) => {
      const heeft = !maat || (k.dataset.maten || '').split(',').some((m) => m.trim() === maat);
      const past = heeft && getoond < hoeveel;
      k.hidden = !past;
      if (past) getoond += 1;
    });

    /* Onder de twee is het geen rij meer maar een losse kaart. */
    sectie.hidden = getoond < 2;
    if (kop && !sectie.hidden && !maat) {
      kop.textContent = sectie.dataset.ookmaatKopLeeg || basiskop;
    }
    if (kop && !sectie.hidden && maat) {
      /* De onthouden maat is de korte schrijfwijze ("38", "40 2/3"); in een
         kop leest "EU 38" beter. Staat er al een maatstelsel voor, dan niet
         nog een keer. */
      const toon = /^[0-9]/.test(maat) ? 'EU ' + maat : maat;
      kop.textContent = basiskop.replace(/jouw maat/i, 'maat ' + toon);
    }
  };

  filter();

  /* Kiest iemand hier een maat, dan klopt de rij meteen mee. De maat wordt
     weggeschreven in de klikafhandeling hierboven, dus even wachten tot die
     klaar is. */
  document.addEventListener('click', (e) => {
    if (e.target.closest('.maat')) setTimeout(filter, 60);
  });
})();
